// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4486c39c","208":"d48986aa","240":"6acec336","300":"51a2eb60","394":"53e23cfa","453":"dde59424","454":"58fad7f4"}[chunkId] + ".chunk.js";
};